import { useAuthStore } from '@/stores/auth'
import { $ResetPinia } from '@/stores/ExtendedPinia';
import { useWebportalStore } from '@/stores/webportal';
import { jwtDecode } from 'jwt-decode';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import router from '@/router';
import { useBluetoothStore } from '@/stores/bluetooth';

const logoutGuard = (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  //Logout user and send them to the login page
  const authStore = useAuthStore();

  // Check if principal has a linked registration to also logout on Virtwass Web.
  let logoutVirtwassWeb = false;
  let virtwassUrl = ''
  if (authStore.VLtoken && (jwtDecode(authStore.VLtoken) as any).unique_name) {
    virtwassUrl = useWebportalStore().virtwassUrl;
    logoutVirtwassWeb = true;
  }

  const bluetoothStore = useBluetoothStore();
  bluetoothStore.bluetoothSerial.isConnected().then(connected => {
    if (connected) {
      bluetoothStore.bluetoothSerial.disconnect();
    }
  });

  authStore.logout();

  // remove all store data
  $ResetPinia();

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  if (!isMobile && virtwassUrl && logoutVirtwassWeb) {
    const loginRoute = router.resolve('/login');
    const absoluteLoginURL = new URL(loginRoute.href, window.location.origin + window.location.pathname).href;
    const virtwassWebLogoutURL = `${virtwassUrl}logout?redirect=${encodeURIComponent(absoluteLoginURL)}`;
    window.open(virtwassWebLogoutURL, "_self", "noopener noreferrer");
  }

  //Remove debtors
  next('/login');
}

export default logoutGuard